import {detailServicesPath} from "../../Constants";
import axios from "axios";

const detailControllerRestUrl = detailServicesPath + '/organizations/compositions/variables-detail-pattern'

export default class CompositionsPatternVariablesService {
    static async save(moduleId, detailPatternId, data) {
        return await axios.post(`${detailControllerRestUrl}?moduleId=${moduleId}&detailPatternId=${detailPatternId}`, JSON.stringify(data), {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }

    static async delete(variableId) {
        return await axios.delete(`${detailControllerRestUrl}/${variableId}`, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }

    static async edit(variableId, data) {
        return await axios.put(`${detailControllerRestUrl}/${variableId}`, JSON.stringify(data), {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }

    static async prevAll(detailId, data) {
        return await axios.post(`${detailControllerRestUrl}/preview-all?detailId=${detailId}`, JSON.stringify(data), {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }
}